import React, { useRef } from 'react';
import './Tooltip.css';

interface TooltipProps {
    children: React.ReactElement;
    text: string,
    width: number,
    mode?: 'LEFT' | 'RIGHT', 
    onChildrenElementClicked: (e : any) => void
}


export default function Tooltip({ children, mode, text, width, onChildrenElementClicked: onClick }: TooltipProps) {

    let refToTooltip = useRef<HTMLDivElement>(null);

    let delay : NodeJS.Timeout | undefined;

    const handleMouseLeave = () => {
        const tooltip = refToTooltip.current;
        if (!tooltip) return;

        tooltip.classList.remove('Visible');
        tooltip.classList.add('Hidden');

        if(delay)
            try{clearTimeout(delay)}catch{}
    };

    const handleMouseMove = (e: React.MouseEvent) => {
        const tooltip = refToTooltip.current;
        if (!tooltip) return;
      
        if(delay)
            clearTimeout(delay);

        delay = setTimeout(()=>{

            tooltip.style.top = `20px`;

            tooltip.style.width = `${width}px`;

            if (mode && mode == 'RIGHT')
                tooltip.style.left = `${e.clientX - width - 10}px`;
            else
                tooltip.style.left = `${e.clientX + 20}px`;

            tooltip.classList.remove('Hidden');
            tooltip.classList.add('Visible');
        }, 1500);
        
    };

    const clickHandler = (e : React.MouseEvent) => {

         if(delay)
            clearTimeout(delay);

          const tooltip = refToTooltip.current;
          if (!tooltip) return;

          
        tooltip.classList.remove('Visible');
        tooltip.classList.add('Hidden');

         onClick(e);
    }

    const clonedChild = React.cloneElement(children, {
        onMouseLeave: handleMouseLeave,
        onMouseMove: handleMouseMove,
        onClick: clickHandler
        
    });


    return (
        <>
            {clonedChild}
            <div className="Tooltip Hidden" ref={refToTooltip}>
                <h1>Ajuda</h1>
                <h2>{text}</h2>
            </div>
        </>
    );
}
